export { default } from './TabList';
export type * from './TabList';
